import React from 'react';

import { Loader } from 'components';

export default function Loading({ loading = true, children = null, ...props }) {
  if (loading) {
    return <Loader {...props} />;
  }

  return children;
}
